/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { BackTop, Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

const initial = {
    recruitmentPolicyChangeId: null,
    recruitmentChangeTitleTh:
        'การเปลี่ยนแปลงแก้ไขคำประกาศเกี่ยวกับความเป็นส่วนตัวด้านการสรรหาและคัดเลือกบุคลากร',
    recruitmentChangeTitleEn: 'Changes to the Recruitment Policy',
    recruitmentChangeContentTh: '',
    recruitmentChangeContentEn: '',
    recruitmentChangeIsDisplay: true,
    recruitmentDataControllerTitleTh:
        'ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)',
    recruitmentDataControllerTitleEn: 'Data Controller',
    recruitmentDataControllerContentTh: '',
    recruitmentDataControllerContentEn: '',
    recruitmentDataControllerIsDisplay: true,
    recruitmentDataProtectionTitleTh:
        'เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer: DPO)',
    recruitmentDataProtectionTitleEn: 'Data Protection Officer: DPO',
    recruitmentDataProtectionContentTh: '',
    recruitmentDataProtectionContentEn: '',
    recruitmentDataProtectionIsDisplay: true,
};

export default function Step8(props) {
    const { form, passStep, setStep8, editData } = props;
    const { t } = useTranslation(['hr-policy', 'translation']);

    const [passCheck, setPassCheck] = useState(1);

    const onNextStep = () => {
        setPassCheck(props.passStep);
        if (props.passStep) {
            props.nextStep();
            props.calProgress();
        }
    };
    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (passStep === 1) {
            setPassCheck(passStep);
        }
    }, [passStep]);

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'recruitmentChangeTitleTh',
                'recruitmentChangeTitleEn',
                'recruitmentChangeContentTh',
                'recruitmentDataControllerTitleTh',
                'recruitmentDataControllerTitleEn',
                'recruitmentDataControllerContentTh',
                'recruitmentDataProtectionTitleTh',
                'recruitmentDataProtectionTitleEn',
                'recruitmentDataProtectionContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.recruitmentPolicyChange
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep8(check);
        }
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-xl">
                {t('Policy change and contact channels')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="recruitmentPolicyChange"
                layout="vertical"
                form={form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'recruitmentChangeTitleTh',
                        'recruitmentChangeTitleEn',
                        'recruitmentChangeContentTh',
                        'recruitmentDataControllerTitleTh',
                        'recruitmentDataControllerTitleEn',
                        'recruitmentDataControllerContentTh',
                        'recruitmentDataProtectionTitleTh',
                        'recruitmentDataProtectionTitleEn',
                        'recruitmentDataProtectionContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep8(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Changes to the Recruitment Policy')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentChangeTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`ประกาศนี้อาจมีการปรับปรุงเป็นครั้งคราวเพื่อความเหมาะสมและสอดคล้องกับสถานการณ์ที่อาจมีการเปลี่ยนแปลง และ[company_name]จะมีการแจ้งประกาศที่มีการปรับปรุงใหม่บนเว็บไซต์นี้ [company_name]ขอให้ท่านหมั่นเข้ามาตรวจสอบเว็บไซต์นี้อย่างสม่ำเสมอ`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentChangeContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentChangeTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`This announcement may be periodically updated for appropriateness and compliance with changing circumstances, and [company_name] will provide new updates on this website. [company_name] encourages you to regularly check this website for any updates.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentChangeContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('policy.des7', { ns: 'translation' })}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataControllerTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataControllerContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataControllerTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataControllerContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer:
                    DPO)
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataProtectionTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataProtectionContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataProtectionTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'recruitmentDataProtectionContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex gap-2 items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                // disabled={!passStep}
                                onClick={onNextStep}
                            >
                                {t('Preview')} <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                    {!passCheck ? (
                        <div className="text-red-500 space-x-2 mt-2">
                            <InfoCircleOutlined />
                            <span>
                                {t(
                                    'Unable to preview before release Please complete the required information on each tab',
                                    { ns: 'translation' }
                                )}
                            </span>
                        </div>
                    ) : (
                        <></>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
